import PieChartOutlinedIcon from "@mui/icons-material/PieChartOutlined";
import { Box, Paper, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { Cell, Pie, PieChart } from "recharts";
import type { RegionChartItem } from "../regionChartItems";
import { formatPercent } from "../statisticsFormat";

const REGION_COLORS = ["#3557a1", "#2e7d32", "#ef6c00", "#6a1b9a", "#00838f", "#c62828", "#f9a825", "#5d4037"];
const PIE_SIZE = 120;

interface Props {
  readonly title: string;
  readonly items: RegionChartItem[];
}

const RegionBreakdownChart: FC<Props> = ({ title, items }) => (
  <Paper elevation={0} sx={{ p: 2, mb: 3, border: "1px solid rgba(0,0,0,0.08)", borderRadius: 2 }}>
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", mb: 2 }}>
      <PieChartOutlinedIcon fontSize="small" color="action" />
      <Typography variant="subtitle2" component="h3" sx={{ fontWeight: "bold", color: "text.secondary" }}>
        {title}
      </Typography>
    </Stack>
    {items.length === 0 ? (
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        Brak danych w wybranym okresie
      </Typography>
    ) : (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: `${PIE_SIZE}px 1fr` },
          gap: 2,
          alignItems: "center",
        }}
      >
        <Box sx={{ mx: "auto" }}>
          <PieChart width={PIE_SIZE} height={PIE_SIZE}>
            <Pie
              data={[...items]}
              dataKey="sharePercent"
              nameKey="label"
              outerRadius={PIE_SIZE / 2}
              startAngle={90}
              endAngle={-270}
              stroke="none"
            >
              {items.map((item, index) => (
                <Cell key={item.label} fill={REGION_COLORS[index % REGION_COLORS.length]} />
              ))}
            </Pie>
          </PieChart>
        </Box>
        <Stack spacing={1}>
          {items.map((item, index) => (
            <Stack key={item.label} direction="row" spacing={1} sx={{ alignItems: "center" }}>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor: REGION_COLORS[index % REGION_COLORS.length],
                  flexShrink: 0,
                }}
              />
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {item.label}:{" "}
                <strong>
                  {item.ordersCount} ({formatPercent(item.sharePercent)})
                </strong>
                {item.detail && ` · ${item.detail}`}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Box>
    )}
  </Paper>
);

export default RegionBreakdownChart;
